module.exports = {
   name: 'Client Sub-Type',
   gen_template: `
      {
         "coa": "ASSET",
         "code": "{{random.alphaNumeric}}{{random.number}}{{random.alphaNumeric}}{{random.number}}", 
         "name": "{{lorem.word}}"
      }
   `,
   wizard: {
      add_subtype:{
         actionBtn: 'Save',
         action: 'add_client_sub_type',
         pages: [
            {
               title: 'Client Sub-Type',
               subtitle: 'Configure new client types',
               forms: [
                  {
                     type: 'image', class: 'col-12 col-md-12 ', model: 'icon',
                     imageFormat: 'png', validation: 'required', label: 'Icon'
                  },
                  {
                     type: 'text', form_type: 'text', label: 'Code', model: 'subtype_code',
                     validation: 'required|min:1|max:50', class: 'col-12 col-md-6'
                  },
                  {
                     type: 'text', form_type: 'text', label: 'Name', model: 'subtype_name',
                     validation: 'required|min:3|max:150', class: 'col-12 col-md-6'
                  },
                  {
                     type: 'textarea', form_type: 'text', label: 'Description', model: 'subtype_description',
                     validation: 'required|min:10|max:500', class: 'col-12'
                  },
               ],
            }
         ]
      },
      attach_kyc: {
         actionBtn: 'Save',
         action: 'attach_kyc',
         pages: [
            {
               title: 'Attach KYC',
               subtitle: 'Attach KYC fields to subclass',
               forms: [
                  { type: 'label', class: 'col-12', label: ''},
                  {
                     type: 'select', class: 'col-12', model: 'kyc_field',
                     options: [], validation: 'required', label: 'KYC Field'
                  },
               ],
            }
         ]
      },
   },
   table: {
      title: 'Client Sub-Type',
      subtitle: 'A list of configured Client subtypes',
      table_fields: [
         { name: 'Code', align: 'l' },
         { name: 'Name', align: 'l' },
         { name: 'Description', align: 'l' },
         { name: 'actions', align: 'c' }
      ],
      searchFields: ["code", "name", "name", "code"],
      rowData: [
         { type: 'text', field: 'subtype_code', class: 'left bolder small' },
         { type: 'text', field: 'subtype_name', class: 'left bolder' },
         { type: 'text', field: 'subtype_description', class: 'left bolder' },
         {
            type: 'action', field: 'name', class: 'center', icon: '', actions: [
               // {type: 'title', title: 'Actions'},
               {
                  type: 'menu', title: 'Edit', event: 'client_subtype:edit', icon: 'ico-right', params: [
                     { key: 'client_subtype', field: '*' }
                  ]
               },
               {
                  type: 'menu', title: 'View', event: 'client_subtype:view', icon: 'ico-reply', params: [
                     { key: 'subtype', field: '*' }
                  ]
               },
               // {type: 'divider'},
               {
                  type: 'menu', title: 'Delete', event: 'client_subtype:delete', icon: 'ico-mail-a', params: [
                     { key: 'email', field: 'email' }
                  ]
               },
            ]
         },
      ]
   },
}